<template>
    <v-checkbox
        class="compact"
        color="primary" 
        :input-value="value[schema.name]" 
        @change="$emit('change', $event)"
        :label="schema.label" 
        :hide-details="true" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder"
        outlined
        @mousedown.native="$emit('focus', $event)"
    />
        <!-- @contextmenu.native.prevent="$emit('focus', $event)" -->

    <!-- contextmenu allows right click to focus without changing checkbox value -->
    <!-- mousedown used because click was preventing checkbox from toggling in vuetify -->
</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: Object,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// CheckboxControl.vue?1c5122d9